import { graphql, Link, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
// import AvisVerifiesWidget from "../avisverifies-widget";
import SkeepersWidget from "../skeeper-widget";


const Hero = ({ title, description, bgImage, altBgImage }) => {
  const data = useStaticQuery(query);

  return (
    <>
      {bgImage && (
        <div className="container p-0 ">
          <div className="flex flex-col">
            {!description && title && (<h1 className="text-blue">{title}</h1>)}
          </div>
          <div className="rounded-4xl overflow-hidden mb-8">
            <div className="h-28rem relative">
              <div>
                <GatsbyImage alt={altBgImage || ''} image={getImage(bgImage)} className="object-cover"></GatsbyImage>
              </div>
              <div className="absolute top-0 w-full h-full flex flex-col justify-around items-center p-8">
                {title && (<h1 className="text-black text-center font-bold text-5xl">{title}</h1>)}
                {description && (<p className="text-black font-semibold text-xl text-center">{description}</p>)}
              </div>
            </div>
          </div>
        </div>
      )}
      {
        !bgImage && (
          <div className="p-4 px-4 rounded-4xl overflow-hidden mb-8">
            <div className="h-29rem relative">
              <GatsbyImage className='object-cover w-full h-full absolute left-0 top-0 opacity-50 lg:opacity-100' alt='hero' image={getImage(data.backgrounds.nodes[0].childImageSharp)} ></GatsbyImage>
              <div className="absolute w-full lg:w-7/12 xl:w-5/12 px-4 md:pl-16 top-0 flex flex-col justify-center items-start h-full">
                <h1 className="text-4xl text-blue font-light normal-case leading-snug mb-0">
                  Spécialiste N°1 en France <br />du tote bag personnalisé
                </h1>
                <div className="flex justify-start items-center my-6 gap-8">
                  <div className="">
                    <script src="https://static.elfsight.com/platform/platform.js" async></script>
                    <div className="elfsight-app-999a9ef7-a1d7-43e1-ba16-e1c922e2483b" data-elfsight-app-lazy></div>
                  </div>
                  <div style={{ maxWidth: '200px' }}>
                    <SkeepersWidget id="1d0e025a-34d8-4625-ae2b-bb06de73216c" />
                    {/* <AvisVerifiesWidget /> */}
                  </div>
                </div>
                <Link
                  className="btn btn-blue btn-rounded text-2xl py-3 inline-block text-center h-auto"
                  to="/categorie-produit/tote-bags-personnalises"
                >
                  Personnaliser mon tote bag
                </Link>

              </div>
              {/* <BackgroundSlider
                query={ }
              >
                {[1, 2, 3].map((e, i) => (
                  <div key={e} className="absolute mt-16 w-full sm:w-7/12 pl-16">
                    {i === 0 && <h1 className="text-4xl text-blue font-light normal-case leading-snug mb-14">
                      Tote bag personnalisé ou sac en coton personnalisé ? C’est notre spécialité
                    </h1>}
                    <Link
                      className="btn btn-blue btn-rounded uppercase py-3 rounded-3xl"
                      to="/categorie-produit/tote-bags-personnalises"
                    >
                      Découvrir nos sacs en tissu
                    </Link>
                  </div>
                ))}
              </BackgroundSlider> */}
            </div>
          </div>
        )
      }
    </>)
};

const query = graphql`
      query {
        backgrounds: allFile(
          filter: {sourceInstanceName: {eq: "backgrounds"}, name: {eq: "new_bandeau"}}
        ) {
          nodes {
            relativePath
            childImageSharp  {
              gatsbyImageData(quality: 80, width: 1400)
            }
          }
        }
      }
    `

export default Hero;
